<template>
    <transition name="fade" appear>
        <Modal class="modal--confirm" :title="title" @closed="cancel">
            <template #head>
                <slot name="head" />
            </template>
            <template #content>
                <slot name="content" />
            </template>
            <template #bottom>
                <div v-if="!buttonsHidden" class="modal__confirm">
                    <button
                        v-for="(btn, i) in buttons"
                        :key="`confirm-btn-${i}`"
                        type="button"
                        :class="btn.classes"
                        :disabled="btn.disabled"
                        @click.prevent="btn.click"
                        v-text="btn.label"
                    />
                </div>
            </template>
        </Modal>
    </transition>
</template>

<script>
import i18n from '@speechki-frontend/core/i18n/i18n';
import Modal from './Modal';

export default {
    name: 'ConfirmModal',
    components: {
        Modal,
    },
    props: {
        title: {
            type: String,
            default: null,
        },
        okLabel: {
            type: String,
            default() {
                return i18n.global.t('confirmModal.ok');
            },
        },
        cancelLabel: {
            type: String,
            default() {
                return i18n.global.t('confirmModal.cancel');
            },
        },
        buttonsHidden: {
            type: Boolean,
            default: false,
        },
        buttonsReverse: {
            type: Boolean,
            default: false,
        },
        okDisabled: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        buttons() {
            const result = [
                {
                    classes: [
                        'button',
                        'modal__confirm-button',
                        { 'is-disabled': this.okDisabled },
                    ],
                    disabled: this.okDisabled,
                    click: this.confirm,
                    label: this.okLabel,
                },
                {
                    classes: ['button', 'button--gray', 'modal__confirm-button'],
                    disabled: false,
                    click: this.cancel,
                    label: this.cancelLabel,
                },
            ];

            if (this.buttonsReverse) return result.reverse();
            return result;
        },
    },
    methods: {
        confirm() {
            this.$emit('confirmed');
        },
        cancel() {
            this.$emit('canceled');
        },
    },
};
</script>
